if (!customElements.get("subscribe-popup")) {
  class SubscribePopup extends HTMLElement {
    constructor() {
      super();
      this.popup = this;
      this.overlay = document.querySelector(".subscribe-popup__overlay");
      this.closeBtn = this.querySelector(".subscribe-popup__close");
      this.form = this.querySelector(".subscribe-popup__form");
      this.section = this.closest(".section-subscribe-popup");
      this.wrapper =
        this.parentElement?.classList?.contains("subscribe-popup__wrapper")
          ? this.parentElement
          : this.section?.querySelector(".subscribe-popup__wrapper");
      this.thankyouPopup = this.section?.querySelector(
        ".subscribe-popup__thankyou",
      );
      this.thankyouCloseBtn = this.thankyouPopup?.querySelector(
        ".subscribe-popup__thankyou__close",
      );
      this.thankyouAutoCloseTimer = null;

      const parsedShowLimit = parseInt(this.dataset.showSubscribe);
      this.showLimit = isNaN(parsedShowLimit) ? 3 : parsedShowLimit;

      const parsedDelay = parseInt(this.dataset.delay);
      this.delay = isNaN(parsedDelay) ? 5 : parsedDelay;

      const parsedDayReset = parseInt(this.dataset.dayReset);
      this.dayReset = isNaN(parsedDayReset) ? 1 : parsedDayReset;

      const parsedHideAfterSubscription = parseInt(
        this.dataset.hideAfterSubscription,
      );
      this.hideAfterSubscription = isNaN(parsedHideAfterSubscription)
        ? 100
        : parsedHideAfterSubscription;

      const parsedThankyouHideDelay = parseInt(this.dataset.thankyouHideDelay);
      this.thankyouHideDelay = isNaN(parsedThankyouHideDelay)
        ? 10
        : parsedThankyouHideDelay;

      this.cookieName = "stride_newsletter_popup_count";
      this.subscribedCookieName = "stride_newsletter_subscribed";
      this.lastFocusedElement = null;
      this.boundKeydownHandler = this.handleKeydown.bind(this);

      this.init();
    }

    init() {
      this.bindEvents();

      if (Shopify.designMode) {
        return;
      }

      const successMessage = this.form?.querySelector(
        ".newsletter-form__message--success",
      );

      if (successMessage) {
        const alreadySubscribed = this.getCookie(this.subscribedCookieName);

        if (!alreadySubscribed) {
          this.setCookie(
            this.subscribedCookieName,
            "1",
            this.hideAfterSubscription,
          );
          this.showThankyouPopup();
        }
        return;
      }

      const subscribedCookie = this.getCookie(this.subscribedCookieName);
      if (subscribedCookie !== null && subscribedCookie !== "") {
        return;
      }

      const showAlways = this.showLimit === 0;

      if (showAlways) {
        this.deleteCookie(this.cookieName);
      }

      const currentCount = parseInt(this.getCookie(this.cookieName)) || 0;

      if (showAlways || currentCount < this.showLimit) {
        setTimeout(() => {
          this.show();
          if (!showAlways) {
            this.setCookie(this.cookieName, currentCount + 1, this.dayReset);
          }
        }, this.delay * 1000);
      }
    }

    bindEvents() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener("click", () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener("click", () => {
          if (this.thankyouPopup?.classList.contains("is-active")) {
            this.closeThankyouPopup();
          } else {
            this.close();
          }
        });
      }

      document.addEventListener("keydown", this.boundKeydownHandler);

      if (this.thankyouCloseBtn) {
        this.thankyouCloseBtn.addEventListener("click", () =>
          this.closeThankyouPopup(),
        );
      }
    }

    handleKeydown(e) {
      if (e.key === "Escape" && this.thankyouPopup?.classList.contains("is-active")) {
        this.closeThankyouPopup();
        return;
      }

      if (e.key === "Escape" && this.popup.classList.contains("is-active")) {
        this.close();
        return;
      }

      if (e.key === "Tab") {
        this.trapFocus(e);
      }
    }

    setWrapperInteractiveState(isOpen) {
      if (!this.wrapper) return;
      if (isOpen) {
        this.wrapper.removeAttribute("inert");
        this.wrapper.setAttribute("aria-hidden", "false");
      } else {
        this.wrapper.setAttribute("inert", "");
        this.wrapper.setAttribute("aria-hidden", "true");
      }
    }

    setThankyouInteractiveState(isOpen) {
      if (!this.thankyouPopup) return;
      if (isOpen) {
        this.thankyouPopup.removeAttribute("inert");
        this.thankyouPopup.setAttribute("aria-hidden", "false");
      } else {
        this.thankyouPopup.setAttribute("inert", "");
        this.thankyouPopup.setAttribute("aria-hidden", "true");
      }
    }

    getActivePopup() {
      if (this.thankyouPopup?.classList.contains("is-active")) {
        return this.thankyouPopup;
      }

      if (this.popup.classList.contains("is-active")) {
        return this.popup;
      }

      return null;
    }

    getFocusableElements(container) {
      if (!container) return [];

      return Array.from(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      );
    }

    trapFocus(e) {
      const activePopup = this.getActivePopup();
      if (!activePopup) return;

      const focusable = this.getFocusableElements(activePopup);
      if (!focusable.length) {
        e.preventDefault();
        activePopup.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const current = document.activeElement;
      const isOutside = !activePopup.contains(current);
      const moveToLast = e.shiftKey && (current === first || isOutside);
      const moveToFirst = !e.shiftKey && (current === last || isOutside);

      if (moveToLast) {
        e.preventDefault();
        last.focus();
      } else if (moveToFirst) {
        e.preventDefault();
        first.focus();
      }
    }

    showThankyouPopup() {
      if (!this.thankyouPopup) return;
      this.lastFocusedElement =
        document.activeElement instanceof HTMLElement ? document.activeElement : null;

      if (this.section) {
        this.section.classList.remove("popup-hidden");
      }

      if (this.overlay) {
        this.overlay.classList.add("is-active");
      }

      this.setWrapperInteractiveState(false);
      setTimeout(() => {
        this.thankyouPopup.classList.add("is-active");
        this.setThankyouInteractiveState(true);
        this.thankyouCloseBtn?.focus();
      }, 50);

      document.body.style.overflow = "hidden";

      this.thankyouAutoCloseTimer = setTimeout(() => {
        this.closeThankyouPopup();
      }, this.thankyouHideDelay * 1000);
    }

    closeThankyouPopup() {
      if (!this.thankyouPopup) return;

      if (this.thankyouAutoCloseTimer) {
        clearTimeout(this.thankyouAutoCloseTimer);
        this.thankyouAutoCloseTimer = null;
      }

      this.thankyouPopup.classList.remove("is-active");
      this.setThankyouInteractiveState(false);
      this.setWrapperInteractiveState(this.popup.classList.contains("is-active"));

      if (this.overlay) {
        this.overlay.classList.remove("is-active");
      }

      document.body.style.overflow = "";

      setTimeout(() => {
        if (this.section) {
          this.section.classList.add("popup-hidden");
        }
        this.setWrapperInteractiveState(false);
      }, 400);

      if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
        this.lastFocusedElement.focus();
      }
      this.lastFocusedElement = null;
    }

    show() {
      this.lastFocusedElement =
        document.activeElement instanceof HTMLElement ? document.activeElement : null;

      if (this.section) {
        this.section.classList.remove("popup-hidden");
      }

      if (this.overlay) {
        this.overlay.classList.add("is-active");
      }

      setTimeout(() => {
        this.popup.classList.add("is-active");
        this.setWrapperInteractiveState(true);

        const firstInput = this.popup.querySelector('input[type="email"]');
        if (firstInput) {
          firstInput.focus();
        }

        document.body.style.overflow = "hidden";
      }, 50);
    }

    close() {
      this.popup.classList.remove("is-active");
      this.setWrapperInteractiveState(false);

      if (this.overlay) {
        this.overlay.classList.remove("is-active");
      }

      document.body.style.overflow = "";

      setTimeout(() => {
        if (this.section) {
          this.section.classList.add("popup-hidden");
        }
      }, 400);

      if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
        this.lastFocusedElement.focus();
      }
      this.lastFocusedElement = null;
    }

    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
    }

    getCookie(name) {
      const nameEQ = `${name}=`;
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === " ") {
          cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
          return cookie.substring(nameEQ.length, cookie.length);
        }
      }
      return null;
    }

    deleteCookie(name) {
      this.setCookie(name, "", -1);
    }
  }

  customElements.define("subscribe-popup", SubscribePopup);
}

if (Shopify.designMode) {
  const getCookieInEditor = (name) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  };

  const setPopupInteractiveState = (el, isOpen) => {
    if (!el) return;
    if (isOpen) {
      el.removeAttribute("inert");
      el.setAttribute("aria-hidden", "false");
    } else {
      el.setAttribute("inert", "");
      el.setAttribute("aria-hidden", "true");
    }
  };

  const togglePopupInEditor = (section) => {
    if (!section || !section.classList.contains("section-subscribe-popup")) {
      return;
    }

    const popup = section.querySelector("subscribe-popup");
    const overlay = section.querySelector(".subscribe-popup__overlay");
    const wrapper = section.querySelector(".subscribe-popup__wrapper");
    const thankyouPopup = section.querySelector(".subscribe-popup__thankyou");
    const subscribeTestMode =
      popup && popup.dataset.enableTestMode === "true";
    const thankyouTestMode =
      popup && popup.dataset.thankyouTestMode === "true";

    const isSubscribed = getCookieInEditor("stride_newsletter_subscribed");
    if (isSubscribed && subscribeTestMode) {
      console.log(
        "[Subscribe Popup] User is subscribed - popup would be hidden on storefront",
      );
    }

    if (subscribeTestMode) {
      section.classList.remove("popup-hidden");
      if (overlay) overlay.classList.add("is-active");
      if (popup) popup.classList.add("is-active");
    } else {
      if (popup) popup.classList.remove("is-active");
      if (overlay) overlay.classList.remove("is-active");
    }

    if (thankyouTestMode) {
      section.classList.remove("popup-hidden");
      if (overlay) overlay.classList.add("is-active");
      if (thankyouPopup) thankyouPopup.classList.add("is-active");
    } else {
      if (thankyouPopup) thankyouPopup.classList.remove("is-active");
      if (!subscribeTestMode && overlay) overlay.classList.remove("is-active");
    }

    if (thankyouTestMode) {
      setPopupInteractiveState(thankyouPopup, true);
      setPopupInteractiveState(wrapper, false);
    } else {
      setPopupInteractiveState(thankyouPopup, false);
      setPopupInteractiveState(
        wrapper,
        subscribeTestMode,
      );
    }

    if (!subscribeTestMode && !thankyouTestMode) {
      setTimeout(() => {
        section.classList.add("popup-hidden");
      }, 400);
    }
  };

  const initPopupsInEditor = () => {
    const sections = document.querySelectorAll(".section-subscribe-popup");
    sections.forEach((section) => {
      togglePopupInEditor(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPopupsInEditor);
  } else {
    initPopupsInEditor();
  }

  document.addEventListener("shopify:section:load", (event) => {
    togglePopupInEditor(event.target);
  });

  document.addEventListener("shopify:section:select", (event) => {
    if (event.target.classList.contains("section-subscribe-popup")) {
      const popup = event.target.querySelector("subscribe-popup");
      const overlay = event.target.querySelector(".subscribe-popup__overlay");
      const wrapper = event.target.querySelector(".subscribe-popup__wrapper");
      const thankyouPopup = event.target.querySelector(
        ".subscribe-popup__thankyou",
      );
      const subscribeTestMode =
        popup && popup.dataset.enableTestMode === "true";
      const thankyouTestMode =
        popup && popup.dataset.thankyouTestMode === "true";

      if (subscribeTestMode) {
        event.target.classList.remove("popup-hidden");
        if (overlay) overlay.classList.add("is-active");
        if (popup) popup.classList.add("is-active");
        setPopupInteractiveState(wrapper, true);
      }

      if (thankyouTestMode) {
        event.target.classList.remove("popup-hidden");
        if (overlay) overlay.classList.add("is-active");
        if (thankyouPopup) thankyouPopup.classList.add("is-active");
        setPopupInteractiveState(thankyouPopup, true);
        setPopupInteractiveState(wrapper, false);
      }

      if (subscribeTestMode && !thankyouTestMode) {
        setPopupInteractiveState(wrapper, true);
        setPopupInteractiveState(thankyouPopup, false);
      }
    }
  });

  document.addEventListener("shopify:section:deselect", (event) => {
    togglePopupInEditor(event.target);
  });
}
